import Home from "./pages/Home";
import { NoiseOverlay } from "./components/ui/NoiseOverlay";

function App() {
  return (
    <div className="App">
      <NoiseOverlay />
      <Home />
    </div>
  );
}

export default App;
